export function useImageURL(url: string, size: string = '128x128') {
    const imageURL = useRuntimeConfig().public.imageURL;
    return url.startsWith('http') ? url : `${imageURL}${size}${url}`;
}
